<template>
	<div id="common" style="background-color: #f2f2f2;">
		
		<el-container>
			<!-- 头部 -->
			<el-header style="height: 10rem;">
				<div class="header">
					<div class="header-div">
						<div class="left">
							<img class="img1" :src="info.avatar" />
							<img class="fixedimg" src="../../../assets/shudo/images/u2113.png" />
							<div class="div">
								<div class="div1">{{info.username}}</div>
								
								<div class="div3">{{info.brief}}</div>
							</div>
							
						</div>
						<div class="right">
							<div class="right3" v-if="types<=0" @click="visitorClick()">关注</div>
							<div class="right3" v-if="types>0" @click="visitorClick()" >已关注</div>
							<div class="right1">
								<div class="right2">
									<div>{{info.attention ? info.attention: 0 }}</div>
									<div>粉丝</div>
								</div>
								
								<div class="right2">
									<div>{{info.visitor ? info.visitor: 0 }}</div>
									
									<div>访客</div>
								</div>
							</div>
							
						</div>
					</div>
					<div class="tab">
						<div @click="url('/sponsor_gameall')" :class="type=='/sponsor_gameall' ? 'action':''">赛事</div>
						<div  @click="url('/sponsor_bank')" :class="type=='/sponsor_bank' ? 'action':''">题库</div>
						<div @click="url('/sponsor_question')" :class="type=='/sponsor_question' ? 'action':''">题型</div>
						<div @click="url('/sponsor_article')" :class="type=='/sponsor_article' ? 'action':''">文章</div>
						<div @click="url('/sponsor_books')" :class="type=='/sponsor_books' ? 'action':''">推荐书籍</div>
					</div>
				</div>
			</el-header>  
			<div style="height: 1rem;"></div>
			<el-container style="width: 80%;  margin: auto; padding-bottom:6rem">
				
				<el-main>
					
					
					<router-view></router-view>   
				</el-main>
			</el-container>
		</el-container>
		
	</div>
	
	


</template>

<script>
	export default {
	    data() {
			return {
				type : '/sponsor_gameall',
				merchanthot_id : '',
				info : [],
				types : 0
			}
	    },
		created() {
			let that = this;
			var  query = that.$route.query;
			that.type  = this.$route.path;
			if(query.merchanthot_id){
				that.merchanthot_id = query.merchanthot_id;
				that.infoTpye();
				
				that.$http('post','/api/v1/merchant/merchantuseradd',{merchant_id:that.merchanthot_id,type:1}) .then(function (res) {
					that.infoTpye();
				});
			}
		},
		methods:{
			url(e){
				var url  = e+'?merchanthot_id='+this.merchanthot_id;
				
				this.$router.push(url);
				this.type = e;
				console.log(e)
			},
			visitorClick(){
				let that =this;
				that.$http('post','/api/v1/merchant/merchantuseradd',{merchant_id:that.merchanthot_id,type:0}) .then(function (res) {
					that.$message({message: res.msg,type: 'success'});
					that.infoTpye();
				});
			},
			infoTpye(){
				let that =this;
				that.$http('get','/api/v1/merchant/details?id='+that.merchanthot_id,{}) .then(function (res) {
					that.info = res.data.info;
					that.types = res.data.type;
					console.log(that.info);
				});
			}
		},
	}
	
</script>

<style lang="less">
	.el-header {
		height: 10rem;
		padding: 0;
	}
	.lefttype {
		color: #3d3e40 !important;
		font-size: 0.86rem !important;
	}
	.header {
		color: #FFFFFF;
		background-color: rgba(9, 7, 35, 1);
		width: 100%;
		height: 10rem;
		.header-div {
			width: 70%;
			margin: auto;
			display: flex;
			padding-top: 2rem;
			.left {
				flex: 2;
				display: flex;
				img {
					width: 5rem;
					
				}
				.img1 {
					border-radius: 50%;
					height: 5rem;
				}
				.fixedimg {
					position: absolute;
					top:10.4rem;
					width: 4.6rem;
				}
				.div {
					font-size: 1.2rem;
					padding-left: 1.6rem;
					.div1 {
					
						font-weight: 600;
						padding-top: 1rem;
					}
					
					.div3 {
						position: relative;
						top: 0.4rem;
					
					}
				}
				
			}
			.right {
				flex: 1;
				padding-top: 1.4rem;
				.right1 {
					padding-left: 1rem;
					display: flex;
					font-size: 0.6rem;
					.right2 {
						
						width: 2rem;
						text-align: center;
						line-height: 1.2rem;
					}
				}
				.right3 {
					position: relative;
					top: -0.5rem;
					left: 0.3rem;
					width: 5.4rem;
					text-align: center;
					height: 1.6rem;
					background-color: #FFFFFF;
					color: #000000;
					line-height: 1.6rem;
					border-radius: 0.4rem;
					font-size: 0.6rem;
				}
				
			}
		}
		.tab {
			display: flex;
			width: 50%;
			margin: auto;
			margin-top: 1rem;
			div {
				color: #A4A1A6;
				margin-left: 0.5rem;
				margin-right: 0.5rem;
				height: 1.4rem;
			}
			.action {
				border-bottom: 0.2rem solid rgba(217, 0, 27, 1);
			}
		}
	
	}
	.el-aside {
		margin-left: 1rem;
		height:23.5rem;
		div {
			
			font-size: 0.6rem;
			width: 100%;
			height: 2rem;
			line-height: 2rem;
			border-bottom: 1px solid #e9e9e9 ;
			color: #7F7F7F;
		}
	}
	
</style>
